// @ts-nocheck

import React from 'react';
import Head from 'react-helmet';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import capitalize from 'lodash/capitalize';

import Linker from 'app/shared/modules/Linker';
import Title from 'app/shared/modules/Title';
import TabGroup from 'app/shared/modules/TabGroup';
import TabItem from 'app/shared/modules/TabItem';
import Center from 'app/shared/modules/Center';
import Container from 'app/shared/core/Container';
import AreaCardList from 'app/shared/modules/state-page/AreaCardList';
import AreaActions from 'app/shared/flux/actions/AreaActions';
import ErrorActions from 'app/shared/flux/actions/ErrorActions';
import './style.scss';
import SkeletonStatePage from 'app/shared/modules/skeleton/SkeletonStatePage';
import { areaUtils_stateAreaForPath } from 'app/shared/utils/areaUtils';
import HpBreadcrumb from 'app/shared/modules/HpBreadcrumb';
import pathsManifest from 'app/shared/utils/pathsManifest';
import { registerClientProfilerPage } from 'app/shared/utils/clientProfiler';

const { shape, string, number, objectOf } = PropTypes;

const titleCapitalize = (word) => {
  const start = word[0];
  if (start === start.toUpperCase()) {
    return word;
  } else {
    return capitalize(word);
  }
};

const propTypeAreaCard = shape({
  id: string,
  name: string,
  uriV2: string,
  listingCount: number,
});

const propTypeGeo = objectOf(propTypeAreaCard);

const propTypePropertyType = objectOf(propTypeGeo);

class StatePage extends React.Component {
  static propTypes = {
    stateName: string,
    sitemap: objectOf(propTypePropertyType),
  };

  constructor(props) {
    super(props);
    const { dispatch } = this.props;
    this.handleTransitonToMFStatePage = this.handleTransitonToMFStatePage.bind(this);
  }

  componentDidMount() {
    registerClientProfilerPage('hotpads-state-page');
    const { dispatch, path, isInitialSsrPage } = this.props;
    if (isInitialSsrPage) {
      return false;
    }
    const stateArea = areaUtils_stateAreaForPath(path);
    if (!stateArea) {
      return false; // Invalid state path
    }
    const { id, abbreviation } = stateArea;

    dispatch(AreaActions.loadStatePage({ id, resourceId: abbreviation }));
  }
  serverRouteWillMount(reactContext) {
    const path = reactContext.state.path;
    const stateArea = areaUtils_stateAreaForPath(path);
    if (!stateArea) {
      // Return resolved promise for invalid state paths
      return Promise.resolve();
    }
    const { id, abbreviation } = stateArea;
    const { dispatch } = reactContext.store;
    return dispatch(AreaActions.loadStatePage({ id, resourceId: abbreviation })).catch((error) => {
      dispatch(
        ErrorActions.errorHandler({
          error,
          errorLocation: 'component.statePage.serverRouteWillMount',
          errorClass: 'areaActions',
        }),
      );
    });
  }
  handleTransitonToMFStatePage() {
    const { resourceId } = this.props;
    window.router.transitionTo(`${pathsManifest.SitemapMfPage}/${resourceId}`);
  }
  render() {
    const { areaPageLoading, sitemap, stateName, uriV2, area } = this.props;

    const breadcrumbs = [
      {
        name: 'Sitemap',
        uri: pathsManifest.SitemapPage,
      },
      {
        name: stateName,
        uri: '',
      },
    ];

    if (areaPageLoading) {
      return (
        <div className="StatePage">
          <SkeletonStatePage />
        </div>
      );
    }
    return (
      <div className="StatePage">
        <Head
          title={`${stateName} rentals | HotPads`}
          meta={[
            {
              name: 'description',
              content:
                `Easily search for apartments, houses, condos, affordable housing and for-rent-by-owner ` +
                `properties in the state of ${stateName} by ` +
                `searching your desired city, county or zip code area with the largest and most ` +
                `trusted rental site.`,
            },
          ]}
        />
        <Container>
          <HpBreadcrumb breadcrumbs={breadcrumbs} />
          <Center>
            <Title size="xl" htmlTag="h1">
              <Linker to={uriV2}>{stateName} rentals</Linker>
            </Title>
          </Center>
          <TabGroup loadAllContent customClass="StatePage-tabs">
            {Object.keys(sitemap).map((key) => {
              const propertyTypeTitle = titleCapitalize(key);
              return (
                <TabItem key={key} tabTitle={propertyTypeTitle} className="StatePage-tab">
                  {Object.keys(sitemap[key]).map((geo) => {
                    return (
                      <AreaCardList
                        key={geo}
                        title={`Popular ${geo}`}
                        areas={sitemap[key][geo]}
                        stateName={stateName}
                        stateAbbreviation={area.state}
                      />
                    );
                  })}
                </TabItem>
              );
            })}
          </TabGroup>
        </Container>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const {
    area: { area = {}, sitemap = {} },
  } = state;

  return {
    areaPageLoading: !state.app.loadStatePageComplete,
    path: state.location.current.pathname,
    isInitialSsrPage: state.app.isInitialSsrPage,
    stateName: area.fullName,
    uriV2: area.uriV2,
    resourceId: area.resourceId,
    area,
    sitemap,
  };
};

export default connect(mapStateToProps)(StatePage);
